import fetchHtml5ToGif, { statusPath } from './fetchHtml5ToGif';

const fetchHtml5ToGifCheckStatus = params =>
  fetchHtml5ToGif({
    path: statusPath,
    params,
  }).then(res => res.json());

export default fetchHtml5ToGifCheckStatus;
